import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectThemeMode } from '../../redux/slices/themeSlice';
import { BodyMedium } from '../../components/Texts/index';
import { PHONE_MEDIA_QUERY } from '../../common/responsive';
import StoreButtons from '../../components/StoreButtons';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  height: 100vh;
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  z-index: 1;
`;

const BlueCircle = styled.div`
  position: fixed;
  z-index: 0;
  width: 100vw;
  height: 100vw;
  background: radial-gradient(
    circle,
    ${({ theme }) => theme.primary.primary}50 0%,
    ${({ theme }) => theme.primary.primary}00 50%
  );
  border-radius: 50%;
  @media ${PHONE_MEDIA_QUERY} {
    background: radial-gradient(
      circle,
      ${({ theme }) => theme.primary.primary}50 0%,
      ${({ theme }) => theme.primary.primary}00 75%
    );
  }
`;

const DownloadApp = () => {
  const themeMode = useSelector(selectThemeMode);

  return (
    <Container>
      <BlueCircle />
      <InnerContainer>
        <img
          style={{
            width: '90%',
            maxWidth: '200px',
          }}
          src={
            themeMode === 'light'
              ? '/logo-footer.webp'
              : '/logo-footer-dark.webp'
          }
          alt='Deks Logo'
        />
        <BodyMedium>
          Experience the easiest way to gift on crypto — download Deks today.
        </BodyMedium>
        <StoreButtons />
      </InnerContainer>
    </Container>
  );
};

export default DownloadApp;
